import { render } from "./MdTableHead.vue?vue&type=template&id=6cf3fda4"
import script from "./MdTableHead.vue?vue&type=script&lang=js"
export * from "./MdTableHead.vue?vue&type=script&lang=js"

import "./MdTableHead.vue?vue&type=style&index=0&id=6cf3fda4&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__